import { render, staticRenderFns } from "./starting-point.vue?vue&type=template&id=07539478&scoped=true&"
import script from "./starting-point.vue?vue&type=script&lang=ts&"
export * from "./starting-point.vue?vue&type=script&lang=ts&"
import style0 from "./starting-point.vue?vue&type=style&index=0&id=07539478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07539478",
  null
  
)

export default component.exports